import { useState, useEffect } from 'react';

const usePaginate = ({ status, fetchMore, results }) => {
  const [page, setPage] = useState(1);
  const [shouldPause, setShouldPause] = useState(false);

  const fetchData = async () => {
    setPage(page + 1);
    return fetchMore();
  };

  const resetPage = () => {
    setPage(1);
    setShouldPause(false);
    return 1;
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      document.documentElement;

    if (scrollTop + clientHeight >= scrollHeight - 20 && status !== 'fetching-more' && !shouldPause) {
      fetchData();
    }
  };

  const pausePaginate = () => setShouldPause(true);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [status]);

  return { page, resetPage, pausePaginate };
};

export default usePaginate;
